<template>
  <div>
      <div class="row">
          <div class="col-sm-12">
              <div class="page-title-box">
                  <div class="float-right">
                      <ol class="breadcrumb">
                          <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                          <li class="breadcrumb-item active">Laporan Transaksi</li>
                      </ol>
                  </div>
                  <h4 class="page-title">Laporan Transaksi</h4>
              </div>
          </div>
      </div>

      <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
              <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
              <div class="wrapper-table-default">
                  <div class="row mb-3">
                      <div class="col-12 col-md-4">
                          <label for="" style="margin-top: 10px;">Tanggal Penetapan</label>
                          <date-picker required style="width: 100%" v-model="filter.date" :placeholder="'Dari - Sampai'"
                              format="DD/MM/YYYY" range></date-picker>
                      </div>
                      <div class="col-12 col-md-4">
                          <label for="" style="margin-top: 10px;">Tanggal Transaksi</label>
                          <date-picker required style="width: 100%" v-model="filter.pay_date"
                              :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" range></date-picker>
                      </div>
                      <div class="col-12 col-md-3">
                          <button class="btn btn-primary" @click="loadData" style="margin-top: 33px;">Filter</button>
                          <div class="btn-group ml-2" style="margin-top: 33px;">
                              <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false">
                                  Export Data
                              </button>
                              <div class="dropdown-menu">
                                  <a class="dropdown-item" @click.prevent="exportData('pdf')">PDF</a>
                                  <a class="dropdown-item" @click.prevent="exportData('excel')">EXCEL</a>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="table-responsive">
                    <div class="row mb-3">
                        <div class="col-12 col-md-6">
                            <div style="padding: 8px; background: #1D8D65; color: #fff; cursor: pointer"
                            @click="info.service = !info.service">Summary Berdasarkan Kategori Retribusi</div>
                            <table class="table table-hover" v-if="info.service">
                                <thead>
                                    <th>No</th>
                                    <th>Kategori Retribusi</th>
                                    <th>Jumlah Trx</th>
                                    <th>Total</th>
                                </thead>
                                <tr v-for="(item, index) in dataTransaction.summaries.services" :key="item.name">
                                    <td>{{index + 1}}</td>
                                    <td>{{item.name}}</td>
                                    <td>{{item.count}}</td>
                                    <td>{{item.total ? currency(item.total) : 0}}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">Grand Total</td>
                                    <td>{{dataTransaction.summaries.services.reduce((a, {count}) => a + count, 0)}}</td>
                                    <td>{{currency(dataTransaction.summaries.services.reduce((a, {total}) => a + total, 0))}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-12 col-md-6">
                            <div style="padding: 8px; background: #1D8D65; color: #fff; cursor: pointer"
                            @click="info.payment = !info.payment">Summary Berdasarkan Metode Pembayaran</div>
                            <table class="table table-hover" v-if="info.payment">
                                <thead>
                                    <th>No</th>
                                    <th>Metode</th>
                                    <th>Jumlah Trx</th>
                                    <th>Total</th>
                                </thead>
                                <tr v-for="(item, index) in dataTransaction.summaries.payment_methods" :key="item.name">
                                    <td>{{index + 1}}</td>
                                    <td>{{item.name}}</td>
                                    <td>{{item.count}}</td>
                                    <td>{{item.total ? currency(item.total) : 0}}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">Grand Total</td>
                                    <td>{{dataTransaction.summaries.payment_methods.reduce((a, {count}) => a + count, 0)}}</td>
                                    <td>{{currency(dataTransaction.summaries.payment_methods.reduce((a, {total}) => a + total, 0))}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                      <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                          <thead>
                              <tr>
                                  <th>Invoice Code</th>
                                  <th class="text-center">Tanggal Penetapan</th>
                                  <th class="text-center">Tanggal Transaksi</th>
                                  <th class="text-center">Objek Penerimaan</th>
                                  <th class="text-center">Status</th>
                                  <th class="text-right">Total</th>pay_date
                                  <th>Aksi</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(item) in dataTransaction.lists" :key="item.id">
                                  <td>{{ item.invoice_code }}</td>
                                  <th class="text-center" valign="center">
                                      {{ item.invoice_date ? convertDate(item.invoice_date) : '-' }}
                                  </th>
                                  <td class="text-center" v-if="item.payment_method == 'TUNAI'">{{item.invoice_date ? convertDate(item.invoice_date) : '-'}}</td>
                                  <td class="text-center" v-else>{{item.pay_date ? convertDate(item.pay_date) : '-'}}</td>
                                  <td class="text-center">
                                      <span v-for="(service, index) in item.service_name" :key="service+index">
                                          {{service}}
                                          <template v-if="index != item.service_name.length - 1">, </template>
                                      </span>
                                  </td>

                                  <td class="text-right">
                                    <GetStatusInTable :data="item"></GetStatusInTable>
                                </td>

                                  <td class="text-right">{{ currency(item.total) }}</td>
                                  <td>
                                      <button class="btn btn-primary waves-effect waves-light ml-2"
                                          @click.prevent="$refs.detailTransaction.loadDetail(item.id)">
                                          <i class="fas fa-eye"></i>
                                      </button>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>

      <div class="modal fade" id="modalDetail" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-lg">
              <detail-transaction ref="detailTransaction"></detail-transaction>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment"
import fileDownload from 'js-file-download'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    data() {
        return {
            loading: true,
            loadingExport: false,

            info: {
                service: false,
                payment: false,
            },

            filter: {
                company: null,
                organization: null,
                date: [moment()._d, moment()._d],
                pay_date: [moment()._d, moment()._d],
                status: null,
            },

            allCompany: [],
            allOrganization: [],
            dataTransaction: [],
            dataTransactionFiltered: [],
        }
    },
    components: {
        DatePicker
    },
    methods: {
        convertPeriod(period) {
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Minggu'
            }else if(period == 'MONTHLY'){
                return 'Bulan'
            }else{
                return 'Tahun'
            }
        },
        loadDetail(id) {
            this.loadingDetail = true

            $('#modalDetail').modal('show')
            
            this.$http.get(`${this.API_URL}transaction/${id}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                const result = response.data;
                if(result.success) {
                    this.dataDetail = result.data
                    setTimeout(() => {
                        this.loadingDetail = false;
                    }, 100);
                }else {
                    this.sAlert('error', result.message)
                    this.loadingDetail = false;
                }
            })
            .catch(error => {
                this.loadingDetail = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        async loadData() {
            this.loading = true;
            try {
                let storedData = {
                    summary: 1,
                    report_type: 'transaction',
                    company_id: this.filter.company,
                    organization_id: this.filter.organization,
                    status: this.filter.status,
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                    start_pay_date: this.filter.pay_date[0] ? moment(this.filter.pay_date[0]).format('YYYY-MM-DD') : null,
                    end_pay_date: this.filter.pay_date[1] ? moment(this.filter.pay_date[1]).format('YYYY-MM-DD') : null
                }

                const transaction = await this.$http.get(`${this.API_URL}transaction`, 
                    {
                        params: storedData,
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` 
                    }
                })
                this.dataTransaction = transaction.data.data

                setTimeout(() => {
                    this.dataTableSearch()
                }, 500);
                
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        async exportData(type) {
            this.loadingExport = true;
            try {
                let storedData = {
                    report_type: 'transaction',
                    company_id: this.filter.company,
                    organization_id: this.filter.organization,
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                    status: this.filter.status,
                    start_pay_date: this.filter.pay_date[0] ? moment(this.filter.pay_date[0]).format('YYYY-MM-DD') : null,
                    end_pay_date: this.filter.pay_date[1] ? moment(this.filter.pay_date[1]).format('YYYY-MM-DD') : null,
                    export: 1,
                    export_type: type
                }

                const response = await this.$http.get(`${this.API_URL}transaction`, {
                    responseType: 'blob',
                    params: storedData,
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                    }
                })

                const typeData = type == 'pdf' ? '.pdf' : '.xlsx'
                fileDownload(response.data, 
                `Laporan Transaksi${this.filter.company ? '-' + this.allCompany.find(item => item.id == this.filter.company).name : ''}${this.filter.date[0] ? '-' + this.filter.date[0] : ''}${this.filter.date[1] ? '-' + this.filter.date[1] : ''}${typeData}`);
                this.loadingExport = false

            } catch (error) {
                console.log(error);
                this.loadingExport = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        convertDate(date){
            return moment(date).format('DD MMMM YYYY')
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>